import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import footerLogo from '../../Images/footer_log.png';

const DashboardFooter = () => {
  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.div variants={itemVariants} style={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: { xs: '1rem', sm: '0.5rem', md: '0.5rem' },
          gap: 2,
          width: '100%',
          borderTop: '1px solid #0000001A',
          boxSizing: 'border-box',
          flexWrap: 'wrap',
          backgroundColor: '#0F172A',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0, }}>
          <Typography
            sx={{
              fontSize: '0.8rem',
              background: 'linear-gradient(135deg, #9333EA 0%, #EC4899 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              fontFamily:
                'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
              fontWeight: 500,
            }}
          >
            Powered By
          </Typography>
          <Box
            component="img"
            src={footerLogo}
            alt="HYPERMINDS Logo"
            sx={{
              height: 24,
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        </Box>
        <Box sx={{ display: 'flex', gap: { xs: 2, sm: 3 }, flexWrap: 'wrap', flexShrink: 0, px: 2 }}>
          {['Docs', 'Support', 'Status', 'Security'].map((link) => (
            <Typography
              key={link}
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: { xs: '0.8rem', sm: '0.8rem', md: '0.9rem' },
                lineHeight: '24px',
                letterSpacing: '-0.31px',
                color: '#4A5565',
                cursor: 'pointer',
                '&:hover': { color: '#2F5D63' },
              }}
            >
              {link}
            </Typography>
          ))}
        </Box>
      </Box>
    </motion.div>
  );
};

export default DashboardFooter;
